<template>
  <label for="expiry" class="text-body-secondary"
    >Stamp Card Validity (Reward Expiry)</label
  >
  <li class="ms-4">
    Members must (i) complete the stamp card AND (ii) redeem the reward before
    it expires. Once expired, all collected stamps will be invalid.
  </li>

  <FlexRow
    class="gap-4 rounded-2 border align-items-center justify-content-between p-2"
  >
    <FlexRow class="gap-2 flex-grow-1 align-items-center">
      <img src="@/assets/svg/IconCalendarStar.svg" />

      <span v-if="!editing">
        {{ expiryText }}
      </span>

      <template v-else-if="editDuration">
        <FlexCol>
          <div>
            Valid for
            <input
              type="number"
              class="text-input"
              style="min-width: 4rem; width: 4rem; margin: 0"
              v-model="duration"
            />
            day(s) from 1st Stamp Collected
          </div>
          <small v-if="duration < 10" class="text-primary">
            Please choose at least 10 days, or select No Expiry.
          </small>
        </FlexCol>
      </template>
      <div v-else id="expiry-dropdown" class="dropdown w-100">
        <div
          class="cursor-pointer border-0 w-100"
          :class="{ 'pe-none': !editing }"
          data-bs-toggle="dropdown"
        >
          {{ Object.values(options).find((option) => option.active).label }}
        </div>

        <ul class="dropdown-menu">
          <li
            @click="selectOption(key)"
            class="dropdown-item"
            v-for="(option, key) in options"
            :key="key"
          >
            {{ option.label }}
          </li>
        </ul>
      </div>
    </FlexRow>

    <template v-if="editing">
      <FlexRow class="gap-1">
        <button class="btn btn-outline-light btn-sm" @click="cancelExpiry">
          Cancel
        </button>
        <button
          class="btn btn-primary btn-sm"
          :disabled="duration < 10 && options.with.active"
          @click="saveExpiry"
        >
          Save
        </button>
      </FlexRow>
    </template>
    <PencilIcon v-else class="cursor-pointer" @click="editing = !editing" />
  </FlexRow>
</template>
<script setup>
import PencilIcon from "@/components/icon/PencilIcon.vue";
import FlexRow from "@/components/layout/FlexRow.vue";
import { useRewardSetupStore } from "@/stores/rewardSetup";
import { computed, ref } from "vue";

const rewardStore = useRewardSetupStore();

const editing = ref(false);
const editDuration = ref(false);
const duration = ref(rewardStore.rewardExpiry);
const options = ref({
  none: {
    label: "No Expiry",
    active: true,
  },
  with: {
    label: "Valid for x day(s) from 1st Stamp Collected",
    active: false,
  },
});

const expiryText = computed(() => {
  const expiry = rewardStore.rewardExpiry;

  if (!expiry) return "No Expiry";
  return `Valid for ${expiry} day(s) from 1st Stamp Collected`;
});

const selectOption = (key) => {
  Object.keys(options.value).forEach((k) => {
    options.value[k].active = k === key;
  });

  if (options.value.with.active) {
    editDuration.value = true;
  }
};

const cancelExpiry = () => {
  editing.value = false;
  editDuration.value = false;
};

const saveExpiry = () => {
  if (options.value.none.active) {
    rewardStore.rewardExpiry = null;
  } else {
    rewardStore.rewardExpiry = duration.value;
  }

  editing.value = false;
  editDuration.value = false;
};
</script>
<style scoped>
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
  appearance: textfield;
}
</style>
